import type { NuxtUiTheme } from '../types/nuxt-ui-theme';
import {
    selectTriggerStyles,
    selectValueStyles,
    selectPlaceholderStyles,
    selectContentStyles,
    selectViewportStyles,
    selectGroupLabelStyles,
    selectItemStyles,
    selectItemTrailingIconStyles,
    selectIndicatorIconStyles
} from '../shared-styles';

export default {
    variants: {
        variant: {
            neumorphic: {
                base: selectTriggerStyles,
                trailing: 'flex shrink-0 items-center',
                trailingIcon: selectIndicatorIconStyles,
                value: selectValueStyles,
                placeholder: selectPlaceholderStyles,
                arrow: selectIndicatorIconStyles,
                content: selectContentStyles,
                viewport: selectViewportStyles,
                group: 'py-2',
                label: selectGroupLabelStyles,
                separator: 'my-2 h-px bg-(--slate-muted-alpha-20)',
                item: selectItemStyles,
                itemLeadingIcon: 'size-5 shrink-0 text-(--text-light)',
                itemTrailingIcon: selectItemTrailingIconStyles,
                itemLabel: 'flex-1 text-current!'
            }
        }
    }
} satisfies NuxtUiTheme['select'];
